<template>
  <div class="d-flex mb-3 controls align-items-center">
    <div class="d-flex align-items-center">
      <div class="mr-4">
        <b-form @submit.prevent="onSearch">
          <b-form-group label="Search:" label-for="custom-search" class="mb-0 search-group">
            <b-input-group>
              <b-form-input
                class="custom-search"
                name="custom-search"
                v-model="searchText"
                :placeholder="searchPlaceholder"
              ></b-form-input>
              <b-input-group-append>
                <b-button type="submit" aria-label="Search" class="search-button">
                  <i class="fa fa-search"></i>
                </b-button>
                <b-button
                  type="button"
                  class="ml-2 clear-button"
                  v-if="searchText"
                  aria-label="Clear"
                  @click="clearSearch">
                  <i class="fa fa-times"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-form>
      </div>

      <b-form-group
        v-if="showApprovalDropdown"
        label="Approval Type:"
        label-for="approval-type"
        class="mb-0 limit-group ms-4"
      >
        <b-form-select
          id="approval-type"
          v-model="localSelectedApprovalType"
          :options="approvalOptions"
          @change="onApprovalTypeChange"
          class="custom-limit-select"
        ></b-form-select>
      </b-form-group>
    </div>

    <!-- Right side: slot + Records dropdown grouped together -->
    <div class="d-flex align-items-center ml-auto">
      <!-- Slot for additional filters before Records dropdown -->
      <slot name="before-records"></slot>

      <b-form-group
        label="Records:"
        label-for="custom-limit"
        class="mb-0 limit-group"
      >
        <b-form-select
          name="custom-limit"
          v-model="limit"
          :options="limitOptions"
          @change="onLimitChange"
          class="custom-limit-select"
        ></b-form-select>
      </b-form-group>
    </div>
  </div>
</template>


  <script>
  export default {
    name: 'SearchSection',
    props: {
      // Allow parent components to customize the placeholder text
      searchPlaceholder: {
        type: String,
        default: 'Search for...'
      },
      showApprovalDropdown: {
        type: Boolean,
        default: false
      },
      selectedApprovalType: {
          type: String,
          default: null
        },
    },
    watch: {
      selectedApprovalType(newVal) {
        if (newVal !== this.localSelectedApprovalType) {
          this.localSelectedApprovalType = newVal;
        }
      }
    },
    data() {
      return {
        searchText: '',
        localSelectedApprovalType: this.selectedApprovalType,
        // Default limit for records per page
        limit: 10,
        // Options for your custom limit dropdown
        limitOptions: [
          { value: 10, text: '10' },
          { value: 25, text: '25' },
          { value: 50, text: '50' },
          { value: 100, text: '100' }
        ],
        //Options to filter requests by approval type
        approvalOptions: [
          {value: null, text:"Select an approval type", disabled: true}, //placeholder
          {value:"All", text:"All"},
          {value: "Protopia", text:"Protopia Approvals"},
          {value: "Customer", text:"Customer Approvals"}
        ],
      };
    },
    methods: {
      onSearch() {
        // Emit an event with the search text so that the parent can react.
        this.$emit('search', this.searchText);
      },
      onLimitChange() {
        // Emit an event with the new limit value.
        this.$emit('limit-change', this.limit);
      },
      onApprovalTypeChange(){
        //Emit an event to filter the request by approval type
        this.$emit('approval-type-change', this.localSelectedApprovalType);
      },
      clearSearch() {
        // Clear the search text and emit the search event with an empty string.
        this.searchText = '';
        this.$emit('search', this.searchText);
      }
    }
  };
  </script>
